<template>
    <div style="border: 1px solid #d9d9d9; border-radius: 4px; padding: 4px">
        <div v-for="message in sortedMessages" :key="message.id" class="d-flex mt-2">
            <div class="d-flex">
                <v-avatar size="32" >
                    <v-auto-img :src="message.src.imageurl" />
                </v-avatar>

                <div class="ml-2">
                    <div><b>{{message.src.name}}</b></div>
                    <div class="z-small-font text--secondary">{{message.created.dateTime()}}</div>
                </div>
            </div>
            <div class="ml-2">
                {{message.content}}
            </div>
        </div>

        <v-row class="mt-4" dense>
            <v-col md="8" cols="12">
                <v-text-field dense hide-details :placeholder="$translate('Write a comment')" outlined v-model="newcomment" @keydown.enter="comment"></v-text-field>
            </v-col>
            <v-col md="4" cols="12">
                <v-btn block :disabled="!newcomment" @click="comment" :loading="posting" color="primary">{{$translate('Send comment')}}</v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: 'zoezi-workout-discussion',

    props: {
        workout: {}
    },

    data: () => ({
        messages: [],
        newcomment: null,
        unsubscribe: null,
        posting: false
    }),

    watch: {
        workout: {
            immediate: true,
            handler(workout) {
                if (workout) {
                    this.getMessages();
                }
            }
        }
    },

    computed: {
        sortedMessages() {
            return this.messages.concat().sort((a, b) => a.created - b.created)
        }
    },

    methods: {
        getMemberImage(member) {
            return document.location.protocol + '//' + window.location.host + '/api/memberapi/image/member/get?size=50x50&id=' + member.id;
        },
        getMessages() {
            this.$api.get('/api/memberapi/workout/message/get', {id: this.workout.id}).then(messages => {
                messages.forEach(m => {
                    m.created = Date.newFull(m.created);
                    m.src.imageurl = this.getMemberImage(m.src)
                })
                this.messages = messages;
                this.$emit('count', messages.length)
            })
        },
        comment() {
            let content = this.newcomment;
            if (!content) {
                return;
            }
            this.newcomment = null;
            this.posting = true;
            this.$api.post('/api/memberapi/workout/message/add', {id: this.workout.id, content }).then(() => {
                this.posting = false;
            })
        }
    },

    mounted() {
        this.unsubscribe = this.$api.subscribe({type: 'workout', callback: (_, event) => {
            if (this.workout && this.workout.id && event.data.find(item => item.id == this.workout.id)) {
                this.getMessages();
            }
        }});
    },
    destroyed() {
        this.unsubscribe?.();
    }
}
</script>